// import _get from 'lodash.get';
// import { getSiteDomain } from 'utils/common';
import {
  TOI_LIVE_DOMAIN,
  UNIFIED_FEED_DOMAIN,
  CMS_CLOUD_SERVING_DOMAIN,
  CMS_API,
} from 'constants/index';
import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import { getS2Sdomain } from 'utils/common';

const getVisualStories = () => ({
  type: '‘bottom’',
  title: 'Visual Stories',
  feedclass: 'visualstoriesas',
  ga4Type: 'visualstories',
  theme: 'cardtype1',
  apiType: 'p',
  itemCount: 10,
  msid_mapping_id: 'newvsstories',
  msid: 'newvsstories',
  // isCloudServiceData: true,
  dataUrl: `${UNIFIED_FEED_DOMAIN}/wufs/feed/list/mixed?client=toi&pc=toi&dm=t&msid=-2128958273&pp=10&cp=1&api_type=LH&type=SLIDESHOW&includeMeta=592:1&sortBy=DATE`,
});
const getVideoWidget = () => ({
  widgetTitle: 'Videos',
  ga4Type: 'Videos',
  msid_mapping_id: '3812907',
  apiType: 'h',
  itemCount: 10,
  msid: '3812907',
});

const getTrendingLinkWidget = () => ({
  widgetTitle: 'Hot Picks',
  ga4Type: 'hotpicks',
  msid_mapping_id: '95271818',
  apiType: 'p',
  itemCount: 10,
  msid: '95271818',
});

const getPhotostories = () => ({
  name: 'Photostories',
  tn: 'PhotoStories_widget',
  className: 'photoGalWidgetBottom',
  msid: 'newPhotostory',
  msid_mapping_id: 'newPhotostory',
  path: `${TOI_LIVE_DOMAIN}/photostories`,
  // isCloudServiceData: true,
  dataUrl: `${UNIFIED_FEED_DOMAIN}/wufs/feed/list/mixed?client=toi&pc=toi&dm=t&msid=-2128958273&pp=10&cp=1&api_type=LH&type=SLIDESHOW&excludeMeta=592:1&sortBy=DATE`,
});

const getBigBossPhotostories = () => ({
  name: 'Bigg Boss',
  tn: 'bigBossPhotostory',
  className: 'photoGalWidgetBottom',
  msid: '71417752',
  msid_mapping_id: '71417752',
  path: '/tv/hindi/bigg-boss',
});

const getTrendingStories = () => ({
  id: 'Featured_Widget',
  tn: 'Featured_Widget',
  className: 'photoGalWidgetBottom',
  apiType: 'p',
  itemCount: 10,
  msid: '96754741',
  msid_mapping_id: '96754741',
  name: 'Trending Stories',
  secName: 'TOI',
});

const getEtimesTrendingStories = () => ({
  id: 'Featured_Widget',
  tn: 'Featured_Widget',
  className: 'photoGalWidgetBottom',
  apiType: 'p',
  itemCount: 10,
  msid: '117324949',
  msid_mapping_id: '117324949',
  name: 'Trending Stories',
  secName: 'Etimes',
});

const getHteWidget = () => ({
  type: 'hteWidget',
  id: 'hteWidget',
  msid: 'hteWidget',
  msid_mapping_id: 'hteWidget',
  ga4Type: 'hteWidget',
  isCloudServiceData: true,
  dataUrl: `${CMS_CLOUD_SERVING_DOMAIN}${CMS_API}/priority/115440109?contenttype=ALL&hostid=83&perpage=3`,
});
const getPollWidget = () => ({
  type: 'pollWidget',
  id: 'pollWidget',
  msid: 'pollWidget',
  msid_mapping_id: 'pollWidget',
  ga4Type: 'pollWidget',
  responseKey: 'items',
  dataUrl: `${getS2Sdomain()}/web_xml_feed_news_list/tag-poblockstudyabroad,feedtype-sjson.cms`,
});

const getCalculatorData = () => [
  {
    tn: 'calculator',
    items: [
      {
        name: 'EMI Calculator',
        fullName: 'Equated Monthly Installment',
        desc: 'Determine the monthly installment amount for a loan',
        url: '/business/financial-calculators/emi-calculator',
        imageId: '118625374',
        msid: '90106184',
        gaLabelName: 'emi',
      },
      {
        name: 'SIP Calculator',
        fullName: 'Systematic Investment Plan Calculator',
        desc: 'Estimate the returns on investments made through SIPs',
        url: '/business/financial-calculators/sip-calculator',
        imageId: '118625372',
        msid: '90106184',
        gaLabelName: 'sip',
      },
      {
        name: 'PPF Calculator',
        fullName: 'Public Provident Fund Calculator',
        desc: 'Find out maturity amount and interest earned on PPF',
        url: '/business/financial-calculators/ppf-calculator',
        imageId: '118625369',
        msid: '90106355',
        gaLabelName: 'ppf',
      },
      {
        name: 'FD Calculator',
        fullName: 'Fixed Deposit Calculator',
        url: '/business/financial-calculators/fixed-deposit-calculator',
        desc: 'Check maturity amount and interest earned on an FD',
        imageId: '118625365',
        msid: '90106388',
        gaLabelName: 'fd',
      },
      {
        name: 'NPS Calculator',
        fullName: 'National Pention Scheme Calculator',
        url: '/business/financial-calculators/nps-calculator',
        desc: 'Estimate the pension amount and corpus accumulated under NPS',
        imageId: '118625364',
        msid: '90421269',
        gaLabelName: 'nps',
      },
      {
        name: 'Mutual Fund Calculator',
        fullName: 'Mutual Fund Calculator',
        url: '/business/financial-calculators/mutual-fund-returns-calculator',
        desc:
          'A Mutual Fund Calculator helps estimate the future value of investments',
        imageId: '118625358',
        msid: '90405657',
        gaLabelName: 'mutual_fund',
      },
    ],
  },
];

export const getBodyInserts = (sectionInfo = {}, isMobile) => {
  const { sectionL1 = '' } = sectionInfo;
  let commonWebInserts = [
    {
      widgetRef: 'hteWidget',
      position: 2,
    },
    {
      widgetRef: 'electionwdt',
      position: 2,
    },
    {
      type: 'jarvisAd',
      position: 3,
      data: {
        name: 'mgid_second_mrec',
      },
    },
    {
      type: 'hindsight_ad_code',
      position: 4,
      data: {
        name: 'Hindsight Ad Code',
      },
    },
    {
      type: 'custom_ad',
      position: 5,
      data: {
        adsData: {
          name: 'mgid_second_mrec',
        },
      },
    },
  ];
  const webInsertsMapping = {
    business: [],
  };

  const sectionWebInserts = webInsertsMapping[sectionL1] || [];
  const webInserts = [...commonWebInserts, ...sectionWebInserts];

  let commonMobileInserts = [
    {
      position: 'start',
      type: 'live_cricket_score_card',
      dataUrl: `${getFeedUrl()}/toi/web/cricket_score?status=live`,
    },
    {
      widgetRef: 'hteWidget',
      position: 1,
    },
    {
      type: 'custom_ad',
      position: 1,
      data: {
        adsData: {
          name: 'mrec',
        },
      },
    },
    {
      type: 'custom_ad',
      position: 2,
      data: {
        adsData: {
          name: 'mrec1',
        },
      },
    },
    {
      type: 'custom_ad',
      position: 3,
      data: {
        adsData: {
          name: 'mgid_second_mrec',
        },
      },
    },
    {
      widgetRef: 'electionwdt',
      position: 4,
    },
    {
      type: 'custom_ad',
      position: 4,
      data: {
        adsData: {
          name: 'mrec2',
        },
      },
    },
    {
      type: 'custom_ad',
      position: 6,
      data: {
        adsData: {
          name: 'mrec3',
        },
      },
    },
    {
      type: 'custom_ad',
      position: 7,
      data: {
        adsData: {
          name: 'mrec4',
        },
      },
    },
    {
      type: 'custom_ad',
      position: 8,
      data: {
        adsData: {
          name: 'mrec4',
          divId: 'div-gpt-ad-8095-mrec5',
        },
      },
    },
    {
      type: 'custom_ad',
      position: 9,
      data: {
        adsData: {
          name: 'mrec4',
          divId: 'div-gpt-ad-8096-mrec6',
        },
      },
    },
    {
      type: 'custom_ad',
      position: 10,
      data: {
        adsData: {
          name: 'mrec4',
          divId: 'div-gpt-ad-8097-mrec7',
        },
      },
    },
  ];
  const mobileInsertsMapping = {
    business: [],
  };
  if (sectionL1 === 'spotlight') {
    commonWebInserts = [];
    commonMobileInserts = [];
  }
  const sectionMobileInserts = mobileInsertsMapping[sectionL1] || [];
  const mobileInserts = [...commonMobileInserts, ...sectionMobileInserts];

  return isMobile ? mobileInserts : webInserts;
};

export const getWidgetMapping = (sectionInfo = {}) => {
  const { sectionL1 = '', sectionL2 = '' } = sectionInfo;
  const commonWidgetMapping = {
    visualStories: {
      ...getVisualStories(),
    },
    trendingBottomWidgetLinks: {
      ...getTrendingLinkWidget(),
    },
    photostory: {
      ...getPhotostories(),
    },
    hteWidget: {
      ...getHteWidget(),
    },
  };
  const widgetMappings = {
    sports: {
      trendingBottomWidgetLinks: {
        ...getTrendingLinkWidget(),
        widgetTitle: 'Top Sports News',
        msid_mapping_id: '95761702',
        msid: '95761702',
      },
      photostory: {},
    },
    'study-abroad': {
      pollWidget: {
        ...getPollWidget(),
      },
    },
    spotlight: {
      photostory: {},
      visualStories: {},
    },
    city: {
      video: {
        ...getVideoWidget(),
      },
      electionwdt: {
        name: 'electionwdt',
        type: 'electionwdt',
      },
    },
    india: {
      video: {
        ...getVideoWidget(),
      },
      electionwdt: {
        name: 'electionwdt',
        type: 'electionwdt',
      },
    },
    world: {
      video: {
        ...getVideoWidget(),
        msid_mapping_id: '68200730',
        msid: '68200730',
      },
    },
    elections: {
      electionwdt: {
        name: 'electionwdt',
        type: 'electionwdt',
      },
    },
  };
  const sectionWidgetMapping = widgetMappings[sectionL1] || {};
  const sectionL2WidgetMapping = widgetMappings[sectionL2] || {};
  return {
    ...commonWidgetMapping,
    ...sectionWidgetMapping,
    ...sectionL2WidgetMapping,
  };
};

export const getWidgetMappingMobile = (sectionInfo = {}) => {
  const { sectionL1 = '', sectionL2 = '' } = sectionInfo;
  const commonWidgetMapping = {
    visualStories: {
      ...getVisualStories(),
    },
    trendingBottomWidgetLinks: {
      ...getTrendingLinkWidget(),
    },
    photostory: {
      ...getPhotostories(),
    },
    hteWidget: {
      ...getHteWidget(),
    },
  };
  const widgetMappings = {
    spotlight: {
      visualStories: {},
      photostory: {},
    },
    business: {
      Featured_Widget: {
        ...getTrendingStories(),
        name: 'Featured In Business',
        secName: 'BUSINESS',
        msid: '1898055',
        msid_mapping_id: '1898055',
      },
      Trending_Widget: {
        ...getTrendingStories(),
        moreLink: `${TOI_LIVE_DOMAIN}`,
      },
      calculatorData: getCalculatorData(),
    },
    india: {
      Featured_Widget: {
        ...getTrendingStories(),
        name: 'Featured In India',
        secName: 'INDIA',
        msid: '-2128936835',
        msid_mapping_id: '-2128936835',
        // apiType: 'h',
      },
      Trending_Widget: {
        ...getTrendingStories(),
        moreLink: `${TOI_LIVE_DOMAIN}`,
      },
      video: {
        ...getVideoWidget(),
      },
      electionwdt: {
        name: 'electionwdt',
        type: 'electionwdt',
      },
    },
    world: {
      Featured_Widget: {
        ...getTrendingStories(),
        name: 'Featured In World',
        secName: 'WORLD',
        msid: '296589292',
        msid_mapping_id: '296589292',
      },
      Trending_Widget: {
        ...getTrendingStories(),
        moreLink: TOI_LIVE_DOMAIN,
      },
      visualStories: {
        ...getVisualStories(),
        path: `${TOI_LIVE_DOMAIN}/life-style/parenting/web-stories`,
      },
      video: {
        ...getVideoWidget(),
        msid_mapping_id: '68200730',
        msid: '68200730',
      },
    },
    religion: {
      Featured_Widget: {
        ...getTrendingStories(),
        name: 'Featured In Astrology',
        secName: 'ASTROLOGY',
        msid: '65857041',
        msid_mapping_id: '65857041',
      },
      Trending_Widget: {
        ...getTrendingStories(),
        moreLink: TOI_LIVE_DOMAIN,
      },
    },
    astrology: {
      Featured_Widget: {
        ...getTrendingStories(),
        name: 'Featured In Astrology',
        secName: 'ASTROLOGY',
        msid: '65857041',
        msid_mapping_id: '65857041',
      },
      Trending_Widget: {
        ...getTrendingStories(),
        moreLink: TOI_LIVE_DOMAIN,
      },
    },
    education: {
      Featured_Widget: {
        ...getTrendingStories(),
        name: 'Featured In Education',
        secName: 'EDUCATION',
        msid: '93114663',
        msid_mapping_id: '93114663',
      },
      Trending_Widget: {
        ...getTrendingStories(),
        moreLink: TOI_LIVE_DOMAIN,
      },
    },
    technology: {
      Featured_Widget: {
        ...getTrendingStories(),
        name: 'Featured In Technology',
        secName: 'TECHNOLOGY',
        msid: '106755835',
        msid_mapping_id: '106755835',
      },
      Trending_Widget: {
        ...getTrendingStories(),
        moreLink: TOI_LIVE_DOMAIN,
      },
    },
    sports: {
      Featured_Widget: {
        ...getTrendingStories(),
        name: 'Featured In Sports',
        secName: 'SPORTS',
        msid: '4719148',
        msid_mapping_id: '4719148',
      },
      trendingBottomWidgetLinks: {
        ...getTrendingLinkWidget(),
        widgetTitle: 'Top Sports News',
        msid_mapping_id: '95761702',
        msid: '95761702',
      },
      Trending_Widget: {
        ...getTrendingStories(),
        moreLink: TOI_LIVE_DOMAIN,
      },
      InternationalSports: {
        name: 'International Sports',
        id: 'sports',
        tn: 'NewsListWithSubSections',
        msid: '62555900',
        msid_mapping_id: '62555900',
        apiType: 'h',
        itemCount: 6,
        ga4Type: 'international_sports_widget',
        path: '/sports/international-sports',
        moreText: 'More International Sports news',
        subSectionsLayout: 'list',
      },
      visualStories: {},
    },
    auto: {
      Featured_Widget: {
        ...getTrendingStories(),
        name: 'Featured In Auto',
        moreLink: `${TOI_LIVE_DOMAIN}/auto`,
        secName: 'AUTO',
        msid: '74317216',
        msid_mapping_id: '74317216',
      },
      Trending_Widget: {
        ...getTrendingStories(),
        moreLink: TOI_LIVE_DOMAIN,
      },
    },
    city: {
      mixedSlider: {
        ...getTrendingStories(),
        tn: 'mixedSlider',
        name: 'Featured In City',
        theme: 'tworowsslider',
        gaAction: 'featured-in-city',
        moreText: 'More City Stories',
        path: `${TOI_LIVE_DOMAIN}/city`,
        feedclass: 'noBorder',
        msid_mapping_id: 'citylatest',
        msid: 'citylatest',
        dataUrl: `${UNIFIED_FEED_DOMAIN}/wufs/fetch/latest/city/articles`,
      },
      Trending_Widget: {
        ...getTrendingStories(),
        moreLink: TOI_LIVE_DOMAIN,
      },
      video: {
        ...getVideoWidget(),
      },
      electionwdt: {
        name: 'electionwdt',
        type: 'electionwdt',
      },
    },
    'study-abroad': {
      pollWidget: {
        ...getPollWidget(),
      },
    },
    elections: {
      electionwdt: {
        name: 'electionwdt',
        type: 'electionwdt',
      },
    },
  };
  const sectionWidgetMapping = widgetMappings[sectionL1] || {};
  const sectionL2WidgetMapping = widgetMappings[sectionL2] || {};
  return {
    ...commonWidgetMapping,
    ...sectionWidgetMapping,
    ...sectionL2WidgetMapping,
  };
};

export const getEtimesWidgetMapping = (sectionInfo = {}) => {
  const { sectionL1 = '' } = sectionInfo;
  const commonWidgetMapping = {
    visualStories: {
      ...getVisualStories(),
      msid: '83837476',
      msid_mapping_id: '83837476',
    },
    photostory: {
      ...getPhotostories(),
    },

    hteWidget: {
      ...getHteWidget(),
    },
  };
  const widgetMappings = {
    tv: {
      bigBossPhotostory: {
        ...getBigBossPhotostories(),
      },
    },
    'life-style': {
      Featured_Widget: {
        ...getEtimesTrendingStories(),
        name: 'Health +',
        msid: '115961244',
        msid_mapping_id: '115961244',
        dataUrl: `${UNIFIED_FEED_DOMAIN}/wufs/feed/solr/search/metadata/web?source=toi&dm=t&client=toi&contentType=all&metaValue=health plus&metaProp=categorytags`,
      },
    },
  };
  const sectionWidgetMapping = widgetMappings[sectionL1] || {};
  return {
    ...commonWidgetMapping,
    ...sectionWidgetMapping,
  };
};

export const getEtimesWidgetMappingMobile = (sectionInfo = {}) => {
  const { sectionL1 = '' } = sectionInfo;
  const commonWidgetMapping = {
    visualStories: {
      ...getVisualStories(),
      msid: '83837476',
      msid_mapping_id: '83837476',
      path: `${TOI_LIVE_DOMAIN}/etimes/web-stories`,
    },
    photostory: {
      ...getPhotostories(),
    },
    Trending_Widget: {
      ...getEtimesTrendingStories(),
      moreLink: `${TOI_LIVE_DOMAIN}/etimes`,
    },
    hteWidget: {
      ...getHteWidget(),
    },
  };
  const widgetMappings = {
    entertainment: {
      Featured_Widget: {
        ...getEtimesTrendingStories(),
        name: 'Featured In Entertainment',
        msid: '7507116',
        msid_mapping_id: '7507116',
      },
    },
    tv: {
      Featured_Widget: {
        ...getEtimesTrendingStories(),
        name: 'Featured In TV',
        msid: '47553118',
        msid_mapping_id: '47553118',
      },
      bigBossPhotostory: {
        ...getBigBossPhotostories(),
      },
    },
    'life-style': {
      Featured_Widget: {
        ...getEtimesTrendingStories(),
        name: 'Health +',
        msid: '115961244',
        msid_mapping_id: '115961244',
        dataUrl: `${UNIFIED_FEED_DOMAIN}/wufs/feed/solr/search/metadata/web?source=toi&dm=t&client=toi&contentType=all&metaValue=health plus&metaProp=categorytags`,
      },
    },
    'web-series': {
      Featured_Widget: {
        ...getEtimesTrendingStories(),
        name: 'Featured In Web Series',
        msid: '115415306',
        msid_mapping_id: '115415306',
      },
    },
  };
  const sectionWidgetMapping = widgetMappings[sectionL1] || {};
  return {
    ...commonWidgetMapping,
    ...sectionWidgetMapping,
  };
};

export const getSectionMsidMapping = widgetMapping => {
  try {
    if (!widgetMapping || typeof widgetMapping !== 'object') {
      throw new Error('Invalid widgetMapping: expected an object.');
    }

    const bodyData = Object.values(widgetMapping)
      .filter(widget => {
        if (!widget.msid || typeof widget.msid !== 'string' || widget.dataUrl) {
          // console.warn(
          //   'Skipping widget due to missing or invalid msid:',
          //   widget,
          // );
          return false;
        }
        return true;
      })
      .map(widget => ({
        apiType: widget.apiType || 'p',
        itemCount: widget.itemCount || 10,
        msid: widget.msid,
      }));

    return bodyData;
  } catch (error) {
    console.error('Error in getSectionMsidMapping:', error.message);
    return [];
  }
};

export const readAlsoWidgetCityMapping = cityName => {
  // Normalize city name variations
  const cityVariations = {
    bangalore: 'Bangalore',
    bengaluru: 'Bangalore',
    delhi: 'Delhi',
    'new delhi': 'Delhi',
    gurugram: 'Gurugram',
    gurgaon: 'Gurugram',
  };

  const normalizedCityName = cityName?.toLowerCase();
  const mappedCityName = cityVariations[normalizedCityName] || cityName;

  const mapping = {
    Delhi: {
      aqi:
        'https://timesofindia.indiatimes.com/weather/new-delhi-aqi-level-air-quality-index-today/3291',
      weather:
        'https://timesofindia.indiatimes.com/weather/new-delhi-weather-forecast-today/110011',
      bank_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/delhi',
      public_holiday:
        'https://timesofindia.indiatimes.com/india/public-holidays/delhi',
      gold:
        'https://timesofindia.indiatimes.com/business/gold-rates-today/gold-price-in-delhi',
      silver:
        'https://timesofindia.indiatimes.com/business/silver-rates-today/silver-price-in-delhi',
    },
    Mumbai: {
      aqi:
        'https://timesofindia.indiatimes.com/weather/mumbai-aqi-level-air-quality-index-today/3258',
      weather:
        'https://timesofindia.indiatimes.com/weather/mumbai-weather-forecast-today/400070',
      bank_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/maharashtra',
      public_holiday:
        'https://timesofindia.indiatimes.com/india/public-holidays/maharashtra',
      gold:
        'https://timesofindia.indiatimes.com/business/gold-rates-today/gold-price-in-mumbai',
      silver:
        'https://timesofindia.indiatimes.com/business/silver-rates-today/silver-price-in-mumbai',
    },
    Bangalore: {
      aqi:
        'https://timesofindia.indiatimes.com/weather/bangalore-aqi-level-air-quality-index-today/3261',
      weather:
        'https://timesofindia.indiatimes.com/weather/bengaluru-weather-forecast-today/560001',
      bank_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/karnataka',
      public_holiday:
        'https://timesofindia.indiatimes.com/india/public-holidays/karnataka',
      gold:
        'https://timesofindia.indiatimes.com/business/gold-rates-today/gold-price-in-bangalore',
      silver:
        'https://timesofindia.indiatimes.com/business/silver-rates-today/silver-price-in-bangalore',
    },
    Hyderabad: {
      aqi:
        'https://timesofindia.indiatimes.com/weather/hyderabad-aqi-level-air-quality-index-today/3288',
      weather:
        'https://timesofindia.indiatimes.com/weather/hyderabad-weather-forecast-today/500002',
      bank_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/telangana',
      public_holiday:
        'https://timesofindia.indiatimes.com/india/public-holidays/telangana',
      gold:
        'https://timesofindia.indiatimes.com/business/gold-rates-today/gold-price-in-hyderabad',
      silver:
        'https://timesofindia.indiatimes.com/business/silver-rates-today/silver-price-in-hyderabad',
    },
    Kolkata: {
      aqi:
        'https://timesofindia.indiatimes.com/weather/kolkata-aqi-level-air-quality-index-today/3309',
      weather:
        'https://timesofindia.indiatimes.com/weather/kolkata-weather-forecast-today/700016',
      bank_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/west-bengal',
      public_holiday:
        'https://timesofindia.indiatimes.com/india/public-holidays/west-bengal',
      gold:
        'https://timesofindia.indiatimes.com/business/gold-rates-today/gold-price-in-kolkata',
      silver:
        'https://timesofindia.indiatimes.com/business/silver-rates-today/silver-price-in-kolkata',
    },
    Chennai: {
      aqi:
        'https://timesofindia.indiatimes.com/weather/chennai-aqi-level-air-quality-index-today/3246',
      weather:
        'https://timesofindia.indiatimes.com/weather/chennai-weather-forecast-today/600017',
      bank_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/tamil-nadu',
      public_holiday:
        'https://timesofindia.indiatimes.com/india/public-holidays/tamil-nadu',
      gold:
        'https://timesofindia.indiatimes.com/business/gold-rates-today/gold-price-in-chennai',
      silver:
        'https://timesofindia.indiatimes.com/business/silver-rates-today/silver-price-in-chennai',
    },
    Ahmedabad: {
      aqi:
        'https://timesofindia.indiatimes.com/weather/ahmedabad-aqi-level-air-quality-index-today/3252',
      weather:
        'https://timesofindia.indiatimes.com/weather/ahmedabad-weather-forecast-today/380001',
      bank_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/gujarat',
      public_holiday:
        'https://timesofindia.indiatimes.com/india/public-holidays/gujarat',
      gold:
        'https://timesofindia.indiatimes.com/business/gold-rates-today/gold-price-in-ahemadabad',
      silver:
        'https://timesofindia.indiatimes.com/business/silver-rates-today/silver-price-in-ahemadabad',
    },
    Pune: {
      aqi:
        'https://timesofindia.indiatimes.com/weather/pune-aqi-level-air-quality-index-today/3325',
      weather:
        'https://timesofindia.indiatimes.com/weather/pune-weather-forecast-today/411002',
      bank_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/maharashtra',
      public_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/maharashtra',
      gold:
        'https://timesofindia.indiatimes.com/business/gold-rates-today/gold-price-in-pune',
      silver:
        'https://timesofindia.indiatimes.com/business/silver-rates-today/silver-price-in-pune',
    },
    Noida: {
      aqi:
        'https://timesofindia.indiatimes.com/weather/noida-aqi-level-air-quality-index-today/3319',
      weather:
        'https://timesofindia.indiatimes.com/weather/noida-weather-forecast-today/201301',
      bank_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/uttar-pradesh',
      public_holiday:
        'https://timesofindia.indiatimes.com/india/public-holidays/uttar-pradesh',
      gold:
        'https://timesofindia.indiatimes.com/business/gold-rates-today/gold-price-in-noida',
      silver:
        'https://timesofindia.indiatimes.com/business/silver-rates-today/silver-price-in-noida',
    },
    Gurugram: {
      aqi:
        'https://timesofindia.indiatimes.com/weather/gurgaon-aqi-level-air-quality-index-today/3227',
      weather:
        'https://timesofindia.indiatimes.com/weather/gurgaon-weather-forecast-today/122001',
      bank_holiday:
        'https://timesofindia.indiatimes.com/business/bank-holidays/haryana',
      public_holiday:
        'https://timesofindia.indiatimes.com/india/public-holidays/haryana',
      gold:
        'https://timesofindia.indiatimes.com/business/gold-rates-today/gold-price-in-gurgaon',
      silver:
        'https://timesofindia.indiatimes.com/business/silver-rates-today/silver-price-in-gurgaon',
    },
  };
  return mapping[mappedCityName];
};

export const readAlsoWidgetApplicableCities = [
  '-2128839596',
  '-2128838597',
  '-2128833038',
  '-2128816011',
  '-2128830821',
  '2950623',
  '-2128821153',
  '-2128821991',
  '8021716',
  '6547154',
];
export default getWidgetMapping;
